export class OrderInvalidEmailError extends Error {
    constructor() {
        super('ERROR_INVALID_EMAIL');
    }
}
